export default "__VITE_ASSET__C680fTpJ__"